<div class="control-container__label py-0">
  <span translate>Project Address</span>
</div>

<i class="icon icon-Address_ico btn-icon--geo"></i>
<i *ngIf="autoCompleteAddress" class="icon icon-close_ico btn-icon--clear" (click)="resetValue('clearEvent')"></i>
<input
  (clickOutside)="resetValue('clickOutsideEvent')"
  class="control-container__control"
  type="text"
  id="placesAutocompleteInput"
  name="placesAutocompleteInput"
  [(ngModel)]="autoCompleteAddress"
  (ngModelChange)="changeResetState()"
  [placeholder]="'Type address here' | translate"
  (click)="resetValue('clickEvent')"
  (input)="onChangeInput($event)" />
